// extracted by mini-css-extract-plugin
export default {"stepperNavigationWrapper":"styles_stepperNavigationWrapper__4eQ8E"};